(function () {
  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () {
        fn.apply(null, args);
      }, ms);
    };
  }

  function maxHeightPx(shell) {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    var v = mobile ? shell.dataset.maxHMobile : shell.dataset.maxHDesktop;
    var n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 396;
  }

  function onMaxHeightTransitionEnd(inner, fn) {
    var done = false;
    function handler(e) {
      if (e.propertyName !== 'max-height') return;
      done = true;
      inner.removeEventListener('transitionend', handler);
      fn();
    }
    inner.addEventListener('transitionend', handler);
    setTimeout(function () {
      if (!done) {
        inner.removeEventListener('transitionend', handler);
        fn();
      }
    }, 500);
  }

  function updateShell(shell) {
    var inner = shell.querySelector('.specs__description-inner');
    var btn = shell.querySelector('.specs__description-toggle');
    if (!inner || !btn) return;

    var maxPx = maxHeightPx(shell);
    shell.style.setProperty('--specs-desc-max-height', maxPx + 'px');

    var readMore = btn.dataset.labelMore || 'Lees meer';
    var readLess = btn.dataset.labelLess || 'Lees minder';

    var overflow = inner.scrollHeight > maxPx + 2;

    if (!overflow) {
      shell.classList.remove('specs__description-shell--is-clamped');
      shell.classList.remove('specs__description-shell--is-open');
      shell.classList.remove('specs__description-shell--expand-done');
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = readMore;
      shell.style.removeProperty('--specs-desc-expanded-height');
      return;
    }

    shell.classList.add('specs__description-shell--is-clamped');
    btn.hidden = false;
    if (shell.classList.contains('specs__description-shell--is-open')) {
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = readLess;
    } else {
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = readMore;
    }
  }

  function bindShell(shell) {
    var inner = shell.querySelector('.specs__description-inner');
    var btn = shell.querySelector('.specs__description-toggle');
    if (!inner || !btn || shell.dataset.specsBound === '1') return;
    shell.dataset.specsBound = '1';

    var readMore = btn.dataset.labelMore || 'Lees meer';
    var readLess = btn.dataset.labelLess || 'Lees minder';

    btn.addEventListener('click', function () {
      if (shell.dataset.specsAnimating === '1') return;

      var opening = !shell.classList.contains('specs__description-shell--is-open');

      if (opening) {
        var fullOpen = inner.scrollHeight;
        shell.style.setProperty('--specs-desc-expanded-height', fullOpen + 'px');
        shell.dataset.specsAnimating = '1';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            shell.classList.add('specs__description-shell--is-open');
            btn.setAttribute('aria-expanded', 'true');
            btn.textContent = readLess;

            onMaxHeightTransitionEnd(inner, function () {
              shell.classList.add('specs__description-shell--expand-done');
              shell.dataset.specsAnimating = '0';
            });
          });
        });
      } else {
        var fullClose = inner.scrollHeight;
        shell.style.setProperty('--specs-desc-expanded-height', fullClose + 'px');
        shell.dataset.specsAnimating = '1';
        shell.classList.remove('specs__description-shell--expand-done');

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            shell.classList.remove('specs__description-shell--is-open');
            btn.setAttribute('aria-expanded', 'false');
            btn.textContent = readMore;

            onMaxHeightTransitionEnd(inner, function () {
              shell.dataset.specsAnimating = '0';
            });
          });
        });
      }
    });

    var run = function () {
      updateShell(shell);
    };

    inner.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', run);
      }
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run).catch(run);
    } else {
      run();
    }

    window.addEventListener('resize', debounce(run, 150));
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var shells = root.querySelectorAll ? root.querySelectorAll('[data-specs-description]') : [];
    for (var i = 0; i < shells.length; i++) {
      bindShell(shells[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
